// Los cartelitos del calendario de Instagram — ADR-2026-10-07-recorridos-del-calendario.
//
// La misma pieza que Tienda online (`useRecorrido` de `../recorridos`: driver.js con el velo
// oscuro de Atlas, una vez por cuenta). Dos recorridos atados a lo que la persona tiene
// delante: el mes, la primera vez que entra, y el editor, la primera vez que abre un post.
// Los pasos cuyo elemento no se ve (la grilla en vista Lista, por ejemplo) se saltean solos.
import type { DriveStep } from 'driver.js';

/** La primera vez en el calendario. */
export function pasosDelCalendario(): DriveStep[] {
  return [
    {
      element: '[data-tour="ig-agente"]',
      popover: {
        title: 'Tu agente arma el mes',
        description:
          'Contale qué querés mostrar y cada cuánto. Elige piezas de tus creaciones, escribe los textos y busca los mejores horarios. Te muestra el plan y no agenda nada sin tu ok.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="ig-resumen"]',
      popover: {
        title: 'Cómo viene tu mes',
        description:
          'Cuántos posts tenés, cuáles están listos, a cuáles les falta algo y cuál sale primero. Tocá el próximo para abrirlo.',
        side: 'bottom',
        align: 'start',
      },
    },
    // Teléfono: los chips que filtran y la semana (los de escritorio no se ven y se saltean).
    {
      element: '[data-tour="ig-chips"]',
      popover: {
        title: 'Cómo viene tu mes',
        description: 'Cuántos posts tenés y en qué estado. Tocá uno para ver sólo esos: los listos, o los que tienen algo por completar.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="ig-semana"]',
      popover: {
        title: 'Tu semana',
        description:
          'Los puntos son tus posts: verde listo, ámbar le falta algo. Tocá un día para ver sus posts abajo, y el nombre del mes para ver el mes entero.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="ig-nuevo-movil"]',
      popover: {
        title: 'O armalo a mano',
        description: 'Un post nuevo para el día que elegiste, con el mejor horario ya puesto.',
        side: 'top',
        align: 'end',
      },
    },
    {
      element: '[data-tour="ig-grilla"]',
      popover: {
        title: 'Tu mes, de un vistazo',
        description:
          'Cada post muestra su portada y su hora. Verde: listo. Ámbar: le falta algo. Arrastralo a otro día para moverlo, y en un día libre pasá el mouse para sumar uno en el mejor horario.',
        side: 'top',
        align: 'center',
      },
    },
    {
      element: '[data-tour="ig-vista"]',
      popover: {
        title: 'Mes o lista',
        description: 'Si preferís leer el plan día por día, con el texto de cada post, pasá a la lista.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="ig-nuevo"]',
      popover: {
        title: 'O armalo a mano',
        description: 'Un post nuevo, eligiendo vos las piezas, el texto y la hora.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      // Sin elemento: un cartel al centro. Es lo que más conviene saber y no está en ningún botón.
      popover: {
        title: 'Por ahora, lo subís vos',
        description:
          'El calendario guarda tu plan, pero todavía no publica solo. A la hora de cada post, abrilo, descargá las piezas y copiá la descripción.',
      },
    },
  ];
}

/** La primera vez que se abre un post. */
export function pasosDelPost(): DriveStep[] {
  return [
    {
      element: '[data-tour="ig-piezas"]',
      popover: {
        title: 'Fotos y videos',
        description:
          'Sumá de tus creaciones o subí un archivo. Una foto es una publicación, varias son un carrusel y un video solo es un reel. Arrastralas para ordenar: la primera es la portada.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="ig-texto"]',
      popover: {
        title: 'La descripción',
        description:
          'Escribila vos o pedísela a la IA, que mira las piezas. La primera línea es la que se lee antes del «… más»: que enganche.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: '[data-tour="ig-cuando"]',
      popover: {
        title: 'Cuándo sale',
        description:
          'Te sugerimos un horario que no se pisa con tus otros posts. Usalo con un click o elegí otro.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: '[data-tour="ig-preview"]',
      popover: {
        title: 'Así se ve en el feed',
        description: 'Se actualiza mientras editás: la portada, el carrusel y hasta dónde se lee el texto.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '[data-tour="ig-preview-movil"]',
      popover: {
        title: 'Así se ve en el feed',
        description: 'Abrilo para ver la portada, el carrusel y hasta dónde se lee el texto.',
        side: 'top',
        align: 'center',
      },
    },
    {
      element: '[data-tour="ig-guardar-movil"]',
      popover: {
        title: 'Guardá el post',
        description: 'Nada queda en el calendario hasta que lo guardes. Si te vas con cambios, te preguntamos qué hacer.',
        side: 'top',
        align: 'center',
      },
    },
    {
      element: '[data-tour="ig-guardar"]',
      popover: {
        title: 'Guardá el post',
        description:
          'Nada queda en el calendario hasta que lo guardes. Si te vas con cambios, te preguntamos qué hacer.',
        side: 'bottom',
        align: 'end',
      },
    },
  ];
}
